export const TAB_OPTIONS = {
  SECTION: 'SECTION',
  TEMPLATE: 'TEMPLATE',
  SNIPPET: 'SNIPPET',
  RECENTNOTES: 'RECENTNOTES',
  LABS: 'LABS',
}

export const noteAccessErrorMessage =
  'This provider cannot start or sign the note because they are not the rendering provider and this is not a shared service.'

export const privateNoteErrorMessage =
  'This note is strictly confidential and viewable solely by the original author.'

export const sspOpenNoteErrorMessage =
  'The Shared Service Provider cannot start a note for this charge.'

export const CCMTitle = 'Chronic Care Management (CCM)'
export const CCMVarname = 'ccm'
export const defaultCCMStatement = `This patient qualifies for Chronic Care Management \
by having 2+ chronic care diagnoses. I have reviewed the Care Coordination program with \
the patient and the patient has verbally consented to enrolling in the Care Coordination program post discharge.`
export const PCMTitle = 'Principal Care Management (PCM)'
export const PCMVarname = 'pcm'
export const defaultPCMStatement = `This patient qualifies for Principal Care Management \
by having 1+ chronic care diagnoses. I have reviewed the Care Coordination program with \
the patient and the patient has verbally consented to enrolling in the Care Coordination program post discharge.`
